"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
function createSvgElement(domElement, tagName) {
    return domElement.ownerDocument.createElementNS(SVG_NAMESPACE, tagName);
}
exports.default = createSvgElement;
//# sourceMappingURL=createSvgElement.js.map